import { maybe } from '@passionware/monads';
import { useSelector } from 'react-redux';
import { AppScopeProvider } from 'v5/core/app-scope/_private/AppScopeProvider';
import { myServices } from 'v5/services/services.connected.app';
import { CommandBarWidget } from './CommandBarWidget';

export function CommandBarWidgetConnected() {
  const loggedIn = useSelector((state: any) => state.auth.loggedIn);
  const scope = myServices.appScopeService.useUrlAppScope();

  if (!loggedIn || maybe.isAbsent(scope)) {
    return null;
  }

  return (
    <AppScopeProvider scope={scope}>
      <CommandBarWidget services={myServices} />
    </AppScopeProvider>
  );
}
